<template>
  <fragment
    v-bind:title="title"
    v-on:remove="$emit('remove')"
  >
    <i>Динамически подставляемое значение</i>
  </fragment>
</template>
<script>
import Fragment from '@/components/NotificationPlan/Fragment.vue';

/**
 * @description Динамический фрагмент формы создания шаблона СМС.
 * @type {Vue}
 */
export default {
  components: {
    Fragment,
  },
  name: 'NotificationPlanDynamic',
  props: {
    ...Fragment.props,
  },
};
</script>
